export const RESUME_TOKEN_STORAGE_KEY = "ai-triage-resume-token";
export const ASK_SCAN_QUERY_PARAM = "ask_scan";
const MILLISECONDS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const RESUME_TOKEN_TTL_HOURS = 24;
export const RESUME_TOKEN_TTL_MS =
  RESUME_TOKEN_TTL_HOURS *
  MINUTES_PER_HOUR *
  SECONDS_PER_MINUTE *
  MILLISECONDS_PER_SECOND;

function parseStoredResumeRecord(raw) {
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    if (
      parsed &&
      typeof parsed.token === "string" &&
      parsed.token.length > 0 &&
      typeof parsed.storedAt === "number"
    ) {
      return parsed;
    }
  } catch (_error) {
    // Legacy bare tokens are treated as expired so they cannot linger.
  }

  return null;
}

export function readStoredResumeToken(
  storage = window.localStorage,
  now = Date.now
) {
  try {
    const record = parseStoredResumeRecord(
      storage.getItem(RESUME_TOKEN_STORAGE_KEY)
    );
    if (!record || now() - record.storedAt > RESUME_TOKEN_TTL_MS) {
      storage.removeItem(RESUME_TOKEN_STORAGE_KEY);
      return null;
    }
    return record.token;
  } catch (_error) {
    return null;
  }
}

export function writeStoredResumeToken(
  token,
  storage = window.localStorage,
  now = Date.now
) {
  try {
    if (!token) {
      storage.removeItem(RESUME_TOKEN_STORAGE_KEY);
      return;
    }
    storage.setItem(
      RESUME_TOKEN_STORAGE_KEY,
      JSON.stringify({ token, storedAt: now() })
    );
  } catch (_error) {
    // Private mode can throw; same-visit session still owns the chat.
  }
}

export function consumeAskScanQuery(search, href) {
  const params = new URLSearchParams(search || "");
  const token = params.get(ASK_SCAN_QUERY_PARAM);
  if (!token) {
    return { token: null, nextUrl: null };
  }

  params.delete(ASK_SCAN_QUERY_PARAM);
  const nextQuery = params.toString();
  const url = new URL(href || "https://scan.com/");
  url.search = nextQuery;
  return {
    token,
    nextUrl: `${url.pathname}${url.search}${url.hash}`,
  };
}
